import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './Sections.module.css';
import featureImg1 from '../Images/land-finding-img1.png';
import featureImg2 from '../Images/land-finding-img2.png';
import { PrimaryButton } from '../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { createResourceLocatorString } from '../../../util/routes';
import routeConfiguration from '../../../routing/routeConfiguration';

function FeatureSection() {
  const history = useHistory();
  const redirectToTrustedSuppliers = (page = 'TrustedSuppliersPage') => {
    history.push(createResourceLocatorString(page, routeConfiguration(), {}, {}));
  };

  return (
    <div className={css.featureSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.featureInfo}>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg1} alt="" />
            </div>
            <div className={css.featureDetails}>
              <h3>
                <FormattedMessage id="ArchitectsAndPlanningConsultancyPage.FeatureSection.architectureTitle" />
              </h3>
              <p>
                <FormattedMessage id="ArchitectsAndPlanningConsultancyPage.FeatureSection.architectureDescription" />
              </p>
              <PrimaryButton
                className={css.trustedSupplierBtn}
                type="button"
                onClick={() => redirectToTrustedSuppliers('SearchPage')}
              >
                <FormattedMessage id="ArchitectsAndPlanningConsultancyPage.FeatureSection.button" />
              </PrimaryButton>
            </div>
          </div>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg2} alt="" />
            </div>
            <div className={css.featureDetails}>
              <h3>
                <FormattedMessage id="ArchitectsAndPlanningConsultancyPage.FeatureSection.planningTitle" />
              </h3>
              <p>
                <FormattedMessage id="ArchitectsAndPlanningConsultancyPage.FeatureSection.planningDescription" />
              </p>
              <PrimaryButton
                className={css.trustedSupplierBtn}
                type="button"
                onClick={() => redirectToTrustedSuppliers('TrustedSuppliersPage')}
              >
                <FormattedMessage id="ArchitectsAndPlanningConsultancyPage.trustedSupplier" />
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeatureSection;
